export default "/assets/log-food.svg";